import React, { useState } from 'react';
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "Andy has worked on our website for two years now and our business has increased steadily thanks to him. We highly recommend him and are extremely satisfied with his work.",
      name: "Mark McGowan",
      company: "Sooty & Sweeps Chimney Co",
      image: "/api/placeholder/80/80" // Placeholder for avatar
    },
    {
      id: 2,
      quote: "Despite only launching last year, I have seen some fantastic results for my tutoring website since Andy started working his SEO magic!",
      name: "Alex Flegg",
      company: "Great Expectations Tutoring",
      image: "/api/placeholder/80/80" // Placeholder for avatar
    },
    {
      id: 3,
      quote: "Our online visibility has improved dramatically since working with Amplified SEO. Their affordable packages provide excellent value for small businesses.",
      name: "Sarah Johnson",
      company: "Johnson's Bakery",
      image: "/api/placeholder/80/80" // Placeholder for avatar
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="section bg-primary text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute left-0 top-10 w-40 h-40 rounded-full bg-accent opacity-10 blur-3xl"></div>
      <div className="absolute right-10 bottom-10 w-40 h-40 rounded-full bg-secondary opacity-10 blur-3xl"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-white mb-4">What our customers are saying</h2>
          <p className="text-white/70 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our clients have to say about working with Amplified SEO.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto relative">
          <div className="absolute top-0 left-0 -mt-8 text-accent opacity-20">
            <FaQuoteLeft size={80} />
          </div>
          
          <div className="relative">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id}
                className={`transition-all duration-500 transform ${
                  index === activeIndex 
                    ? 'opacity-100 scale-100' 
                    : 'opacity-0 scale-95 absolute top-0 left-0'
                }`}
              >
                <div className="text-center">
                  <p className="text-xl md:text-2xl mb-8 px-4">"{testimonial.quote}"</p>
                  <div className="mb-6">
                    <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-4 border-2 border-accent">
                      <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="font-bold text-xl">{testimonial.name}</div>
                    <div className="text-accent">{testimonial.company}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="flex justify-center mt-8 space-x-4">
            <button 
              onClick={prevTestimonial}
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent/20 transition-colors"
              aria-label="Previous testimonial"
            >
              <FaChevronLeft />
            </button>
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === activeIndex ? 'bg-accent' : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                ></button>
              ))}
            </div>
            <button 
              onClick={nextTestimonial}
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent/20 transition-colors"
              aria-label="Next testimonial"
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
